
















































import CustomFieldConfigurationForm from "@/components/report/CustomFieldConfigurationForm.vue";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { requiredRule } from "@/lib/rules/requiredRule";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Project, IProject } from "@/models/project.entity";
import { MrfiktivReferenceGen } from "@/services/mrfiktiv/v1/data-contracts";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import ConfirmActionDialog from "../../utility/ConfirmActionDialog.vue";

@Component({
  components: {
    ConfirmActionDialog,
    CustomFieldConfigurationForm
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class ProjectCreateDialog extends mixins(PermissionMixin) implements IDialog {
  @Prop()
  partnerId!: string;

  @Prop()
  hideButton!: boolean;

  isDialogActive = false;

  isLoading = false;

  project: IProject = new Project({});

  get requiredRule() {
    return [requiredRule()];
  }

  open() {
    this.project = new Project({ partnerId: this.partnerId });
    this.isDialogActive = true;
    this.$nextTick(() => {
      (this.$refs.titleField as HTMLInputElement)?.focus();
    });
  }

  async onRightClick() {
    try {
      this.isLoading = true;
      this.isDialogActive = true;
      await this.project.create();
      this.$emit("created", this.project);
      this.$toast.success("👍");
      this.close();
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
    }
  }

  onConfirm(item: MrfiktivReferenceGen) {
    this.$log.debug("onConfirm", item);
  }

  close(): void {
    this.isDialogActive = false;
  }
}
